import { useStore } from '@/utils/vue-api';
import { computed } from 'vue';
import { getLanguageByType } from '@/locales';
import { resolveStoreId } from '@rebuild/utils/context';
import instance from '@/axios';
import to from 'await-to-js';
import { enterprise } from '@/axios/interface';
import { useCommonData } from '@/hooks';
import { isErrorValue } from '@/utils/api';

export function usePageWithLanguage() {
	const { viewInIframe, viewInPreview } = useCommonData();

	const store = useStore();
	const getPageList = computed(() => store.getters.getPageList);

	const updateIdMapInPageList = async () => {
		const pageList = getPageList.value;
		if (!pageList || !pageList.length) return;

		// 筛选出未获取过 __innerVOS 的页面
		const targetPages = pageList.filter(v => !v.__innerVOS);
		if (!targetPages.length) return;

		const fetchResults = new Map();

		await Promise.all(
			targetPages.map(async page => {
				if (!page.pageId) return;

				const storeId = resolveStoreId();
				if (isErrorValue('storeId', storeId)) return;

				const usePreviewApi = viewInIframe.value || viewInPreview.value;
				const queryApi = usePreviewApi
					? enterprise.getPageSaveContent(storeId, page.pageId)
					: enterprise.getPageDetail(storeId, page.pageId);

				const [err, res] = await to(instance.get(queryApi));
				if (err) return;

				const data = res.data?.data || {};
				const { pageMenuVOS = [] } = data;

				const excludeDefaultMenus = pageMenuVOS.filter(v => !v.isDefault);
				// 第一个可用的菜单，作为首页菜单
				const fstMenu = excludeDefaultMenus.length > 0 ? excludeDefaultMenus[0] : null;
				const indexUuid = fstMenu?.uuid;

				fetchResults.set(page.pageId, { indexUuid });
			})
		);

		if (fetchResults.size > 0) {
			const newPageList = pageList.map(item => {
				if (fetchResults.has(item.pageId)) {
					return {
						...item,
						__innerVOS: fetchResults.get(item.pageId)
					};
				}
				return item;
			});
			store.commit('setPageList', newPageList);
		}
	};

	const findIndexPageInfoByLanguage = language => {
		const pageList = getPageList.value;
		const targetPage = pageList.find(v => getLanguageByType(v.languageType) === language);
		if (!targetPage) return null;

		return {
			pageId: targetPage.pageId,
			indexUuid: targetPage?.__innerVOS?.indexUuid || null
		};
	};

	return {
		updateIdMapInPageList,
		findIndexPageInfoByLanguage
	};
}
